import { render, staticRenderFns } from "./EditVopsit.vue?vue&type=template&id=09f77658&scoped=true"
import script from "./EditVopsit.vue?vue&type=script&lang=js"
export * from "./EditVopsit.vue?vue&type=script&lang=js"
import style0 from "./EditVopsit.vue?vue&type=style&index=0&id=09f77658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f77658",
  null
  
)

export default component.exports